import React, { Component, PropTypes } from 'react';
import { Button, Popover, Pagination, Select, Input, message } from 'antd';

import { Scrollbars } from 'react-custom-scrollbars';
import { NHModal, NHConfirm } from '../common/NHModal';
import DownloadForm from './download';
import UploadForm from './upload';

import styles from './index.css'
import tx from '../../styles/images/tx.jpg'
import NHFetch from "../../utils/NHFetch";
import { hasAuth } from '../../utils/NHCore';
import getSize from '../../utils/getSize' //左侧菜单数据

const Option = Select.Option;
const Search = Input.Search;
var uuid;

export default class StuPhotoMng extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            clientHeight: document.documentElement.clientHeight,
            clientWidth: document.documentElement.clientWidth,
            data: [],
            sign: 'zhxg_yxxt_stuPhoto_groupPage',
            searchParams: {},
            searchField: 'multiField,bmmc,zymc,bjmc,xh,xm,rxnf,xqmc',//通用查询的字段
            searchText: '',//通用查询的值
            pageData: {
                total: 50,
                pageSize: 20,//当前页默认多少条数据
                page: 1
            },
            pageSizeOptions: ['10', '20', '30', '40'],
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.onWindowResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
    }
    componentWillMount() {
        let width = this.state.clientWidth - 328;
        let height = this.state.clientHeight - 336;
        let w = parseInt(width / 137) > 1 ? parseInt(width / 137) : 1;
        let h = parseInt(height / 195) > 1 ? parseInt(height / 195) : 1;
        let pageSize = w * h;
        this.setState({
            pageSizeOptions: [pageSize, pageSize * 2, pageSize * 3, pageSize * 4],
            pageData: {
                total: 50,
                pageSize: pageSize,//当前页默认多少条数据
                page: 1
            }
        }, this.filterData);
    }
    onWindowResize = () => {
        const clientHeight = document.documentElement.clientHeight;
        const clientWidth = document.documentElement.clientWidth;
        this.setState({
            clientHeight: clientHeight,
            clientWidth: clientWidth,
        })
    }

    onShowSizeChange = (current, pageSize) => {
        this.setState({
            pageData: {
                pageSize: pageSize,
                page: current
            }
        }, () => {
            this.readData();
        });
    }
    //获取学生信息
    getData = (params) => {
        NHFetch("/proData/gridList", "POST", params).then(
            res => {
                if (res) {
                    if (res.data) {
                        this.setState({
                            data: res.data.list,
                            pageData: {
                                total: res.data.total,
                                pageSize: this.state.pageData.pageSize,
                                page: this.state.pageData.page
                            }
                        })
                    }
                }
            }
        )
    }
    //打开上传窗口
    upload = () => {
        this.refs.nhAddModal.show();
    }
    //上传文件保存
    save = (stopLoading) => {
        this.refs.nhAddForm.validateFields((err, values) => {

            if (err) {
                stopLoading();
                return;
            }

            NHFetch("api/pub-stuinfo/studentPhoto/resolvePicktureZip", "post", values)
                .then(res => {
                    if (res) {
                        message.success("操作成功！");
                        this.refs.nhAddModal.close();
                    }
                    stopLoading();
                    this.filterData();
                }).catch(err => stopLoading());
        });
    }
    // 自动生成uuid
    uuid = () => {
        let s = [];
        let hexDigits = "0123456789abcdef";
        for (let i = 0; i < 18; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
        s[18] = hexDigits.substr((s[18] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[4] = s[9] = s[14] = "-";

        let uuid1 = s.join("");
        uuid = uuid1

    }
    //根据id拉取照片
    loop = (data) => {
        return data.map((item) => {
            this.uuid();
            return (<li>
                <Popover placement="right"
                    overlayClassName={styles.pto_popover}
                    content={
                        <div>
                            <p><b>性别：</b>{item.XB}</p>
                            <p><b>入学年份：</b>{item.RXNF}</p>
                            <p><b>校区：</b>{item.XQMC}</p>
                            <p><b>学院：</b>{item.BMMC}</p>
                            <p><b>专业：</b>{item.ZYMC}</p>
                            <p><b>班级：</b>{item.BJMC}</p>
                            {/* <p><b>是否报到：</b>是</p> */}
                        </div>}
                    trigger="hover">
                    <div className={styles.avator}>
                        {/* <div style={{ marginTop: 50, fontWeight: 'bold' }}>无照片<br />请上传</div> */}
                        <img src={"api/pub-stuinfo/studentPhoto/getImgByParam?&id=" + item.XSID + "&zhlx=&uuid=" + uuid} />
                    </div>
                    <p className={styles.name}>{item.XM}</p>
                    <p className={styles.id}>{item.XH}</p>
                </Popover>
            </li>);
        })
    }
    //重置操作
    onRest = () => {
        this.setState((prevState, props) => ({
            searchParams: {},//自定义的搜索条件
            searchText: '',
            pageData: {
                total: this.state.pageData.total,
                pageSize: this.state.pageData.pageSize,
                page: 1
            }
        }), function () {
            this.filterData();
        });
    }
    //重新加载数据数据的方法（从第一页开始）
    filterData = () => {
        this.setState((prevState, props) => ({
            pageData: {
                total: this.state.pageData.total,
                pageSize: this.state.pageData.pageSize,
                page: 1
            }
        }));
        this.readData();
    }
    //在当前页刷新数据
    readData = () => {
        let pagination = this.state.pageData;//分页的参数
        let searchParams = this.state.searchParams;//传递过来的查询参数
        if (!searchParams) { searchParams = {}; }
        let params = {
            pagination: pagination,
            sign: this.state.sign,
            filters: {},
            sorter: {},
            searchTextMap: {},//下拉框查询的值,用作查询
            searchParams: searchParams,
            sqlParams: {},
            initParams: {},
            sign: this.state.sign
        };
        this.getData(params);
    }
    //自定义下拉框查询
    zdySearchFieldChange = (value) => {
        this.setState({
            searchField: value
        });
        if (value && this.state.searchText) {
            let searchText = this.state.searchText;
            let searchParams = {};
            searchParams[value] = searchText;
            this.setState({
                searchParams: searchParams
            })
        } else {
            this.setState({
                searchParams: {}
            })
        }
    }
    //搜索操作
    onSearch = () => {
        this.filterData();
    }
    //输入框
    zdySearchTextChange = (e) => {
        this.setState({
            searchText: e.target.value
        });
        if (e.target.value && this.state.searchField) {
            let searchParams = {};
            searchParams[this.state.searchField] = e.target.value;
            this.setState({
                searchParams: searchParams
            });
        } else {
            this.setState({
                searchParams: {}
            })
        }
    }
    //打开下载页面
    download = () => {
        this.refs.downloadModal.show();
    }
    //下载
    downloadFile = () => {
        this.refs.downloadForm.validateFields((err, values) => {
            if (!err) {
                let zhlx = "";
                values["zhlx"].map(item => {
                    zhlx += item + "_";
                });
                zhlx = zhlx.substring(0, zhlx.length - 1);
                if (zhlx.indexOf("xh") == -1 && zhlx.indexOf("ksh") == -1 && zhlx.indexOf("sfzjh") == -1) {
                    NHConfirm("请至少在学号，考生号，身份证件号中选择一项命名条件！", () => { });
                    return;
                }
                let param = {
                    zhlx: values["zhlx"],
                    searchParams: this.state.searchParams
                }
                NHFetch("api/pub-stuinfo/studentPhoto/downloadFile", "nbpost", param)
                    .then(res => {
                        if (res) {
                            this.refs.downloadModal.close();
                            const content = res;
                            const blob = new Blob([content], { type: "application/zip" });
                            let timestamp = new Date().getTime();
                            const fileName = '学生照片_' + timestamp + '.zip';
                            if ('download' in document.createElement('a')) { // 非IE下载
                                const elink = document.createElement('a');
                                elink.download = fileName;
                                elink.style.display = 'none';
                                elink.href = URL.createObjectURL(blob);
                                document.body.appendChild(elink);
                                elink.click();
                                URL.revokeObjectURL(elink.href) // 释放URL 对象
                                document.body.removeChild(elink)
                            } else { // IE10+下载
                                navigator.msSaveBlob(blob, fileName)
                            }
                        }
                    });
            }
        });
    }
    render() {
        const { clientHeight } = this.state;
        const downloadButton = [
            {
                text: "下载",
                onClick: this.downloadFile,
            }
        ];
        return (
            <div style={{ margin: 12, padding: 16, background: '#fff', height: clientHeight - 174 }}>
                <div className={styles.search_box}>
                    <Select
                        defaultValue="multiField,bmmc,zymc,bjmc,xh,xm,rxnf,xqmc" onChange={this.zdySearchFieldChange} dropdownMatchSelectWidth={false} dropdownStyle={{ width: '100px' }}>
                        <Option value="multiField,bmmc,zymc,bjmc,xh,xm,rxnf,xqmc">全部</Option>
                        <Option value="xh">学号</Option>
                        <Option value="xm">姓名</Option>
                        <Option value="rxnf">入学年份</Option>
                        <Option value="xqmc">校区名称</Option>
                        <Option value="yxmc">院系</Option>
                        <Option value="zymc">专业</Option>
                        <Option value="bjmc">班级</Option>
                    </Select>
                    <Search
                        onSearch={this.onSearch}
                        value={this.state.searchText}
                        onChange={this.zdySearchTextChange}
                        placeholder="请输入查询条件"
                        style={{ width: 230 }}
                    />
                    <Button type="primary" style={{ margin: '0 20px' }} onClick={this.onSearch}>查询</Button>
                    <Button type="Default" style={{ paddingLeft: 5 }} icon="reload" onClick={this.onRest} >重置</Button>
                    {/* <Button type="Default" style={{paddingLeft:5}} ghost icon="search">高级搜索</Button> */}
                </div>
                <div style={{ margin: '16px 0' }}>
                    {
                        hasAuth('zhxg_yxgl_jcsj_xszpgl:upload') ?
                            <Button type="primary" onClick={this.upload}>上传照片</Button>
                            : null
                    }
                    {
                        hasAuth('zhxg_yxgl_jcsj_xszpgl:download') ?
                            <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.download}>下载照片</Button>
                            : null
                    }
                    {/* <Button type="primary" ghost style={{ marginLeft: 10 }}>导出没有照片学生</Button> */}
                </div>
                <Scrollbars autoHide style={{ width: '100%', height: clientHeight - 336 }}>
                    <ul className={styles.pho_cont}>
                        {this.loop(this.state.data)}
                    </ul>
                </Scrollbars>
                <div style={{ textAlign: 'right' }}>
                    <Pagination showSizeChanger showQuickJumper onShowSizeChange={this.onShowSizeChange} onChange={this.onShowSizeChange}
                        showTotal={(total, range) => `当前${range[0]}-${range[1]}条  总数${total}条`} size={'small'} pageSizeOptions={this.state.pageSizeOptions}
                        defaultCurrent={this.state.pageData.page} defaultPageSize={this.state.pageData.pageSize} total={this.state.pageData.total} />>
                </div>
                <NHModal ref="nhAddModal"
                    title="学生照片导入" //TODO 把此处的信息改成自己的
                    width={750}
                    onOk={this.save}
                >
                    <UploadForm ref="nhAddForm" />
                </NHModal>
                <NHModal ref="downloadModal"
                    title="学生照片下载"
                    width={750}
                    footer={downloadButton}
                >
                    <DownloadForm ref="downloadForm" count={this.state.pageData.total} />
                </NHModal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/stuPhotoMng/index.js